export const formatInputValue = (value = '') => {
    const date = value.replace(/\D/g, '').substr(0, 8);
    const match = date.match(/^(\d{0,2})(\d{0,2})(\d{0,4})$/);

    if (match) return `${match[1]}${match[2] ? '/' : ''}${match[2]}${match[3] ? '/' : ''}${match[3]}`;
    return date;
};
